import { ENDPOINTS } from "@api/endpoints";
import HttpClient from "@api/HttpClient";

import { ZendeskTokenRes } from "types/responses";

export const postZendeskConfigData = async (mode: string): Promise<ZendeskTokenRes> => {
  const res = await HttpClient.post(ENDPOINTS.help.zendeskConfigurationData, { mode });
  return res.data;
};
